import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsSrvmItem from "./SetsSrvmItem"
import Select from 'react-select'
import SettingsForm from './SettingsForm'

class SetsSrvm extends SettingsForm{

  modelName = 'srvm'

  newItem = {
    srvm_desc: '',
    srvm_active: 1,
    srvm_type: 0
  };

  render() {
    if(isEmpty(this.props.srvms.data)){
      return(<div>Не загружены данные</div>);
    }
    const srvms = this.props.srvms.data;
    const { search, sort } = this.props.srvms;
    const { data, errors } = this.state;

    var fltrSrvms = [];
    for(var key in srvms){
      if(srvms.hasOwnProperty(key)){
        const active = srvms[key].srvm_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + srvms[key].srvm_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrSrvms.push(srvms[key]);
        }
      }
    }

    const srtSrvms = fltrSrvms.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.srvm_id < b.srvm_id)
         return sort.asc ? -1 : 1
      if(a.srvm_id > b.srvm_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedSrvms = srtSrvms ? srtSrvms.map(srvm =>
      <SetsSrvmItem key={srvm.srvm_id}
        data={srvm}
      />
    ) : [];

    var srvmTypesOpt = [
      {
        value: 0,
        label: '(пусто)'
      },
      {
        value: 1,
        label: 'Постоянные расходы'
      },
      {
        value: 2,
        label: 'Условно-постоянный расходы'
      },
      {
        value: 3,
        label: 'Условно-переменные расходы'
      },
      {
        value: 4,
        label: 'Капитальные вложения'
      },
    ];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.srvm_desc}
              name="srvm_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <Select
            clearable={false}
            options={srvmTypesOpt}
            value={data.srvm_type}
            onChange={e => this.updateSelect(e,'srvm_type')}
            placeholder="Тип для отчетов"
          />
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка главных групп услуг</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrSrvms.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th onClick={() => {this.handleSort('srvm_desc')}}>Название</th>
              <th onClick={() => {this.handleSort('srvm_type')}}>Тип для отчетов</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedSrvms}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    srvms: store.srvms
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsSrvm);



// WEBPACK FOOTER //
// ./src/components/settings/SetsSrvm.js